export const getUsernameOutOfEmail = (email: string) => email.split('@')[0] || `user`
